import Base from './components/cells/Base';
import PercentageText from './components/cells/PercentageText';

export default function PercentageTextCell() {}

PercentageTextCell.prototype.init = function (params) {
    this.eGui = Base(PercentageText(params), params);
    return;
};

PercentageTextCell.prototype.getGui = function () {
    return this.eGui;
};
